// Interface

import util from '@/utils/classToObject'
import { IMesureUniteState } from './state'
import { AloDbMesureUnite } from '@/models/alodb/AloDbMesureUnite'

export class MesureUniteGetter {  
      
  public mesureUnites(state:IMesureUniteState,getters:any) {
    return state.mesureUnites
  }

  public modifiedAdmMesureUnite(state:IMesureUniteState,getters:any) {
    return state.modifiedAdmMesureUnite
  }

  public originalAdmMesureUnite(state:IMesureUniteState,getters:any) {
    return state.originalAdmMesureUnite
  }

  public mesureUniteLoading(state:IMesureUniteState,getters:any) {
    return state.mesureUniteLoading
  }

  public mesureUnitesById(state:IMesureUniteState) {     
    return state.mesureUnites.reduce((acc,value) =>{
        acc[value.MUT_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbMesureUnite})      
  }

  public mesureUniteStatus(state:IMesureUniteState) {     
    return state.status
  }

  public adminMesureUniteFilter(state:IMesureUniteState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(MesureUniteGetter)